import { Shift } from '@nextforce/api'
import { makeStyles, Text } from '@rneui/themed'
import { font } from 'app/theme'
import React from 'react'
import { View } from 'react-native'
import { ShiftApproverView } from './approver'

interface Props {
  shift: Shift
  showApprover: boolean
}

export function ShiftStoreAddressView({ shift, showApprover }: Props) {
  const styles = useStyles()

  return (
    <View style={styles.container}>
      <Text style={styles.name}>{`${shift.store.name}`}</Text>
      <Text style={styles.address}>{shift.store.address}</Text>
      {showApprover ? <ShiftApproverView approver={shift.approver} /> : null}
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {},
  name: {
    fontSize: 14,
    fontFamily: font.bold,
    color: theme.colors?.grey1,
  },
  address: {
    fontSize: 13,
    color: theme.colors?.grey1,
  },
}))
